export default function emitEvent (name, info) {
  window.dispatchEvent(new CustomEvent(name, { detail: info }));
}



// WEBPACK FOOTER //
// ./utils/emitEvent.js